import set from "@rill/set";
import rill from "rill";
import ProgramOverview from "../program-library/program-overview";
import ProgramPreview from "../program-library/program-preview";
import EditExercise from "./edit-exercise";
import ProgramBuilder from "./program-builder";
import ProgramEditor from "./program-editor";

const ProgramBuilderController = (app) => {
  app.at(
    "/program-builder/*",
    rill()
      .use(set("heading", ["Athlete", "My Programs"]))
      .setup(EditExercise)
      .setup(ProgramBuilder)
      .setup(ProgramEditor)
      .setup(ProgramOverview)
      .setup(ProgramPreview)
  );
};

export default ProgramBuilderController;
